import { Provider } from "react-redux";
import Posts from "./Components/Posts";
import Store from "./Components/Redux/Store";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <Provider store={Store}>
      <Routes>
        <Route path="/" element={<Posts />} />
      </Routes>
    </Provider>
  );
}

export default App;
